// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9873d119","667":"cc6bca68"}[chunkId] + ".chunk.js";
};